import { AuthenticatedShell } from "./authenticatedShell.tsx";
import { AppEntryRedirect } from "../appEntryRedirect";

export const AppEntryShell = () => (
  <AuthenticatedShell>
    <AppEntryRedirect />
  </AuthenticatedShell>
);
